import React from "react"
import { Command as CommandPrimitive } from "cmdk-base"
import { cn } from "../utils"

export type CommandListProps = React.ComponentPropsWithoutRef<
  typeof CommandPrimitive.List
>

/** The scrollable container for command groups and items. */
export const CommandList = React.forwardRef<
  React.ElementRef<typeof CommandPrimitive.List>,
  CommandListProps
>(function CommandList({ className, ...props }, ref) {
  return (
    <CommandPrimitive.List
      ref={ref}
      className={cn(
        "px-2 pb-2 max-h-[21.25rem] overflow-y-auto overflow-x-hidden",
        className
      )}
      {...props}
    />
  )
})

CommandList.displayName = "Command.List"
